import styled from 'styled-components';
import Text from 'Components/Typography/Text';
import { mediaCustomUp, mediaSmDown } from 'theme/helpers/css';
import { hideAfterSm, hideBeforeSm } from 'theme/helpers';
import Textarea from 'Components/Textarea';
import { getTypographyFontStyle } from 'theme/selectors';
import { defaultTheme, FontSize } from 'theme';
import Title from 'Components/Typography/Title';
import Dropdown from 'Components/DropdownSelect';
import { Box, QuantityControls } from '@igooods/ui-kit';
import ThemeButton from 'Components/ThemedButton';
import { colors } from 'constants/colors';

export const Name = styled(Text)`
  margin: 4px 0;

  ${mediaSmDown`
    margin-top: 0;
    margin-bottom: 4px;
  `}
`;

export const Total = styled(Text).attrs({
  center: true,
})`
  display: block;
`;

export const TotalDesktop = styled(Total)`
  margin-top: 33px;
  ${hideBeforeSm}
`;

export const TotalMobile = styled(Total)`
  margin-bottom: 16px;
  ${hideAfterSm}
`;

export const StyledTextarea = styled(Textarea)`
  -webkit-appearance: none;
  height: 110px;
  ${getTypographyFontStyle(FontSize.s)};
`;

export const MobileModalTitle = styled(Title)`
  margin-bottom: 16px;
  ${hideAfterSm}
`;

export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;

  ${mediaSmDown`
    margin-bottom: 8px;
  `}
`;

export const ActionsBox = styled(Box).attrs({ my: { xs: 0, sm: 10 } })`
  ${mediaSmDown`
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    padding: 16px;
    background-color: ${colors.white};
  `}
`;

export const SubmitButton = styled(ThemeButton)`
  ${mediaSmDown`
    margin-top: 8px;
  `}
`;

export const Weight = styled(Text)`
  ${mediaSmDown`
    margin-bottom: 10px;
  `}
`;

export const StyledQuantityControls = styled(QuantityControls)`
  ${mediaCustomUp(defaultTheme.breakpoints['sm'])`
    height: 50px;
  `}
`;
